export default "__VITE_ASSET__604f9472__"